import Navigation from "./Navigation";
import '../css/About.css'
import PhoneSelfie from '../imgs/about-selfie.svg'

function About(){
    return(
        <div className="About">
            <Navigation />
            <body className="About-body">
                <div className="About-text-box">
                    <h1 className="About-h1">Who am I?</h1>
                    <p className="About-text">
                        Hey there! I’m <b>Avery</b> (although some know me by Yan Yan) and I love to build things on the internet. 
                        <br /><br />
                        My journey into software engineering started sophomore year at <b>Boston University</b> from a spontaneous conversation
                        with some guy sitting across from me in the dining hall. At the time, I was a biochemistry major getting bored of routine
                        lab work so our conversation had led me to take my very first Python class.
                        Funny how major life-changing events happen where you least expect!
                        <br /><br />
                        Fast forward to now, I work at Check in <b>NYC</b> building payroll technologies to help people get paid!

                    </p>
                </div>
                <div className="About-image-container">
                    <img src={PhoneSelfie} alt="phone with anonymous character" className="About-image"/>
                </div>
            </body>
        </div>
    )
}

export default About;